import { INotice, Notifier } from "@airbrake/browser";
import { Injectable } from "@angular/core";
import { environment as appEnv } from "../../environments/environment";

@Injectable()
export class AirbrakeService {
  public notifier: Notifier;

  constructor() {
    const notifier = new Notifier({
      environment: appEnv.envName,
      projectId: appEnv.airbrake.projectId,
      projectKey: appEnv.airbrake.key,
      host: appEnv.airbrake.host,
    });

    notifier.addFilter((notice: INotice) => {
      try {
        const file = notice.errors[0].backtrace[0].file;
        if (/(chrome|safari)-extension:\/\//.test(file)) {
          return null;
        }

        // Ignore errors from the Netsparker security scanner.
        const isNetsparkerUserAgent =
          notice.context.userAgent &&
          notice.context.userAgent.includes("Netsparker Cloud");
        if (isNetsparkerUserAgent) {
          return null;
        }
        // tslint:disable-next-line: no-empty
      } catch (_error) {}
      return notice;
    });

    this.notifier = notifier;
  }
}
